import { useCallback } from 'react';

import { Header } from '@vms/Header';
import { Table } from '@components/Table';
import {
    TogglePublicItemsParams,
    ToggleTranslatedDescriptionsParams,
    useToggleCountryPublicItems,
    useToggleCountryTranslatedDescriptions
} from '@core/api/useCountrySettings';

import { useAppContext } from '../../App.context';
import CountrySettingsTableConfig from './CountrySettingsTableConfig';

const CountrySettings = () => {
    const {
        countrySettings,
        isLoading,
        fetchCountrySettings
    } = useAppContext();

    const {
        doFetch: toggleCountryPublicItems,
        isLoading: isTogglingPublicItems
    } = useToggleCountryPublicItems();

    const {
        doFetch: toggleCountryTranslatedDescriptions,
        isLoading: isTogglingTranslatedDescriptions,
    } = useToggleCountryTranslatedDescriptions();

    const onToggleCountryPublicItems = useCallback(
        (params: TogglePublicItemsParams) => {
            toggleCountryPublicItems({
                params,
            }).then(() => {
                fetchCountrySettings?.();
            });
        },
        [fetchCountrySettings, toggleCountryPublicItems],
    );

    const onToggleCountryTranslatedDescription = useCallback(
        (params: ToggleTranslatedDescriptionsParams) => {
            toggleCountryTranslatedDescriptions({
                params,
            }).then(() => {
                fetchCountrySettings?.();
            });
        },
        [fetchCountrySettings, toggleCountryTranslatedDescriptions],
    );

    return (
        <>
            <Header>Country Settings</Header>
            <CountrySettingsTableConfig
                data={countrySettings}
                onToggleCountryPublicItems={onToggleCountryPublicItems}
                onToggleCountryTranslatedDescription={onToggleCountryTranslatedDescription}
            >
                <Table
                    rowsCount={countrySettings ? countrySettings.length : 0}
                    isLoading={isLoading || isTogglingPublicItems || isTogglingTranslatedDescriptions}
                />
            </CountrySettingsTableConfig>
        </>
    );
};

export default CountrySettings;
